import FJVideoRemoveBgLeftContainer from './FJVideoRemoveBgLeft/container/FJVideoRemoveBgLeftContainer';
import FJVideoRemoveBgRightContainer from './FJVideoRemoveBgRight/container/FJVideoRemoveBgRightContainer';
import { useDispatch } from 'react-redux';
import FJActionVideoRemoveBg from '../../redux/action/FJActionVideoRemoveBg';
import { useEffect } from 'react';
import FJUtil from '../../util/FJUtil';
import FJNotSupportBrowser from '../../common/components/FJNotSupportBrowser/FJNotSupportBrowser';
import useLocalStore from '../../hooks/useLocalStore';

const FJVideoRemoveBg = () => {
    useLocalStore();
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(FJActionVideoRemoveBg.initVideoRemoveBgProjectAction());
    }, [dispatch]);

    const browser = FJUtil.getBrowser();
    const isSafari = browser.includes('Safari');

    if (isSafari) {
        return <FJNotSupportBrowser />;
    }

    return (
        <>
            <FJVideoRemoveBgLeftContainer />
            <FJVideoRemoveBgRightContainer />
        </>
    );
};

export default FJVideoRemoveBg;
